import React from "react";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";
import Table from "@material-ui/core/Table";
import { isValidNumberStringValues } from "../../../../utils/helpers";
import clsx from "clsx";

const Row = (props) => {
  const { row, name, subTableLength, cellWidth } = props;
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();
  const cellClasses = useCellStyles();
  const cellClassesAlt = useCellStylesAlt();
  const cellHeaderStyles = useCellHeaderStyles();
  const iconStyles = useIconStyles();
  const cellHeaderAlt = useCellHeaderStylesAlt();
  
  // Separate TableCell classes from other class names
  const cellHeaderClasses = { root: cellHeaderStyles.root };

  return (
    <React.Fragment>
      <TableRow classes={classes}>
        <TableCell
          classes={cellHeaderClasses}
          component="th"
          scope="row"
        >
          <div className={cellHeaderStyles.arrowNameContainer}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              <KeyboardArrowRightIcon
                className={clsx(iconStyles.icon, { [iconStyles.open]: open })}
              />
            </IconButton>
            {name}
          </div>
        </TableCell>
        {row?.header_totals.map((total, index) => (
          <TableCell
            key={`total-${index}`}
            align="right"
            classes={cellClasses}
            style={{ width: 81.83 }}
          >
            {!isValidNumberStringValues(total) ? total : Math.trunc(total)}
          </TableCell>
        ))}
      </TableRow>
      {open && (
        <TableRow>
          <TableCell
            style={{ padding: 0, width: "110px" }}
            colSpan={subTableLength}
          >
            <Collapse
              in={open}
              timeout="auto"
              unmountOnExit
            >
              {row?.sub_table_body.map((row, rowIndex, arr) => {
                const isLastRowInTable = rowIndex === arr.length - 1;
                return (
                  <Table key={row?.country_name}>
                    <TableHead></TableHead>
                    <TableBody>
                      <TableRow classes={cellHeaderAlt.padding}>
                        <TableCell
                          style={{
                            width: cellWidth,
                            borderBottom: isLastRowInTable ? "none" : undefined,
                          }}
                          classes={cellHeaderAlt}
                          component="th"
                          scope="row"
                        >
                          <div
                            className={clsx(cellHeaderAlt.nameContainer, {
                              [cellHeaderAlt.widthNameContainer]: !cellWidth,
                            })}
                          >
                            {row?.country_name}
                          </div>
                        </TableCell>
                        {row?.data.map((data, index) => {
                          return (
                            <TableCell
                              key={`sub-row-cell-${index}`}
                              align="right"
                              classes={cellClassesAlt}
                              style={
                                isLastRowInTable ? { borderBottom: "none" } : {}
                              }
                            >
                              {!isValidNumberStringValues(data)
                                ? data
                                : Math.trunc(data)}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    </TableBody>
                  </Table>
                );
              })}
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </React.Fragment>
  );
};

export default Row;

const useRowStyles = makeStyles((theme) => ({
  root: {
    background: "var(--White)",
  },
}));

const useCellStyles = makeStyles(() => ({
  root: {
    color: "black",
    textAlign: "center",
    whiteSpace: "nowrap",
    padding: "0px",
    width: "81.83px",
    fontWeight: "bold",
    backgroundColor: "var(--surface-50)",
  },
}));
const useCellStylesAlt = makeStyles(() => ({
  root: {
    textAlign: "center",
    whiteSpace: "nowrap",
    padding: "0px",
    width: "80px",
    minWidth: "80px",
    maxWidth: "80px",
  },
}));

const useIconStyles = makeStyles((theme) => ({
  icon: {
    color: "var(--text-primary)",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  open: {
    transform: "rotate(90deg)",
  },
}));

const useCellHeaderStyles = makeStyles(() => ({
  root: {
    color: "var(--text-primary)",
    width: "202px",
    position: "sticky",
    height: "67px",
    left: 0,
    fontWeight: "bold",
    backgroundColor: "var(--surface-50)",
  },
  arrowNameContainer: {
    display: "flex",
    alignItems: "center",
    width: "169px",
  },
}));

const useCellHeaderStylesAlt = makeStyles(() => ({
  root: {
    width: "201px",
    position: "sticky",
    left: 0,
    paddingBlock: "1rem",
    paddingInline: "0",
  },
  nameContainer: {
    paddingInline: "1rem",
    backgroundColor: "var(--White)",
  },
  widthNameContainer: {
    width: "201px",
  },
}));
